module.exports = __webpack_public_path__ + "img/tutorial_title03.2f9e3c64.svg";